import React from 'react';
import LocationTemplate from './LocationTemplate';

const WindsorPage: React.FC = () => {
  return (
    <LocationTemplate
      cityName="Windsor"
      stateName="North Carolina"
      countyName="Bertie"
      zipCodes={["27983"]}
      latitude={35.9982}
      longitude={-76.9455}
      population={3630}
      historicalFact="Founded in 1768, served as a major shipping port on the Cashie River."
      nearbyTowns={[
        "Plymouth, NC",
        "Williamston, NC",
        "Hamilton, NC",
        "Scotland Neck, NC",
        "Colerain, NC",
        "Askewville, NC",
        "Aulander, NC",
        "Ahoskie, NC"
      ]}
    />
  );
};

export default WindsorPage;